module.exports = __webpack_public_path__ + "0a9bb579d52a61c7d9f8248e9348ff12.pdf";